var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center items-center px-4 h-54 bg-black bg-opacity-30 rounded-3xl"},_vm._l((_vm.page),function(item,index){return _c('span',{key:index,staticClass:"w-6 h-6 rounded-full mx-5 z-10 cursor-pointer",class:index === _vm.slideNumber
        ? 'bg-dark-moderate-violet'
        : 'bg-very-dark-violet',on:{"click":function($event){return _vm.moveToSlide(index)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }